import { __rest } from "tslib";
import { rgba } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { combineValues } from '@clds/component-theme';
import { focusVisible } from '@clds/style-utils';
import { radioTheme, typeVariant } from './theme';
const RadioBase = styled.input `
  position: relative;
  width: ${radioTheme.size};
  height: ${radioTheme.size};
  flex-shrink: 0;
  vertical-align: middle;
  outline: none;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  appearance: none;

  &:before,
  &:after {
    content: '';
    display: block;
    border-radius: 100%;
    transition: all 100ms linear;
  }

  /* outer dot, border and background */
  &:before {
    border-width: 1px;
    border-style: solid;
    border-color: ${typeVariant((branch) => branch.border.color.base)};
    background-color: ${radioTheme.background.color.base};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  /* inner dot, checked marker */
  &:after {
    width: ${radioTheme.radio.size};
    height: ${radioTheme.radio.size};
    background-color: ${typeVariant((branch) => branch.radio.color.active)};
    position: relative;
    opacity: 0;
  }

  &:checked {
    &:before {
      background-color: ${radioTheme.background.color.hover};
      border-color: ${typeVariant((branch) => branch.border.color.hover)};
    }

    &:after {
      opacity: 1;
    }
  }

  &${focusVisible()} {
    &:before {
      background-color: ${radioTheme.background.color.focus};
      box-shadow: 0 0 0 ${radioTheme.focus.shadow.size}
        ${combineValues(radioTheme.focus.color, (color) => rgba(color, 0.5))};
    }
  }

  &:hover {
    &:before {
      background-color: ${radioTheme.background.color.hover};
      border-color: ${typeVariant((branch) => branch.border.color.hover)};
    }
  }

  &:disabled {
    &:before {
      background-color: ${radioTheme.background.color.disabled};
      border-color: ${combineValues(radioTheme.border.color.disabled, (color) => rgba(color, 0.5))};
    }

    &:after {
      background-color: ${combineValues(radioTheme.radio.color.disabled, (color) => rgba(color, 0.5))};
    }
  }
`;
/**
 * Radio is component that only styles native input[type="radio"] element with additional support for validationState
 * property, without any extra logic
 */
export const Radio = (_a) => {
    var { validationState = 'none' } = _a, restProps = __rest(_a, ["validationState"]);
    return (React.createElement(RadioBase, Object.assign({}, restProps, { type: "radio", role: "radio", validationState: validationState, "data-test": "radio" })));
};
//# sourceMappingURL=Radio.js.map